<template>
  <v-container fluid class="pa-0">
    <vueHeadful v-if="getIdioma === 'es'"
      title="TrArtist - Artistas y Diseñadores"
      description="Galería de Artistas y Diseñadores Internacional"
      :url="'https://trartist.com' + $route.fullPath"
      :lang="getIdioma"
    />
    <vueHeadful v-else
      title="TrArtist - Designers and Artists"
      description="International Artists and Designers Gallery"
      :url="'https://trartist.com' + $route.fullPath"
      :lang="getIdioma"
    />
    <v-row name="Duo" v-if="duo" style="margin: 60px 10%;padding: 0;">
      <v-col xs="12" md="6" :class="$vuetify.breakpoint.name === 'lg' ? 'pl-0' : ''">
        <router-link :to="$t('Alias.Artistas')">
          <div :style="'background:'+duo.colorFondo.hex8">
            <v-hover v-slot:default="{ hover }">
              <v-img :id="hover ? 'duo' : ''" :src="duo.imagenArtistas" max-height="700" aspect-ratio="1">
                <v-container fill-height style="justify-content: center">
                  <v-row width="100%">
                  <v-col cols="12" align="center" justify="center">
                    <h2 class="font-weight-black" :style="textoInicio+'color:'+ duo.colorTexto.hex8">{{ $t('Menu.Artistas')?$t('Menu.Artistas').toUpperCase():'' }}</h2>
                  </v-col>
                </v-row>
                </v-container>
              </v-img>
            </v-hover>
          </div>
        </router-link>
      </v-col>
      <v-col xs="12" md="6" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-0' : ''">
        <router-link :to="$t('Alias.Disenadores')">
          <div :style="'background:'+duo.colorFondo.hex8">
            <v-hover v-slot:default="{ hover }">
              <v-img :id="hover ? 'duo' : ''" :src="duo.imagenDisenadores" max-height="700" aspect-ratio="1">
                <v-container fill-height style="justify-content: center">
                  <v-row>
                  <v-col cols="12" align="center" justify="center">
                    <h2 class="font-weight-black" :style="textoInicio+'color:'+ duo.colorTexto.hex8">{{ $t('Menu.Disenadores').toUpperCase() }}</h2>
                  </v-col>
                </v-row>
                </v-container>
              </v-img>
            </v-hover>
          </div>
        </router-link>
      </v-col>
    </v-row>
    <v-row name="Artistas" style="margin: 60px 10% 0px 10%;padding: 0;">
      <v-col cols="12" align="center">
        <h2 class="error--text pb-5" :style="responsiveTitulo">{{$t('Inicio.DescubreArtistas').toUpperCase()}}</h2>
      </v-col>
      <v-col cols="12" xs="12" sm="12">
        <carousel v-bind:autoplay="true" v-bind:loop="true" :perPage="perPageCarousel" v-bind:autoplayTimeout="8000">
          <slide v-for="i in artistas" :key="i.titulo">
            <v-col cols="12" xs="12" sm="12">
              <v-row style="width: -webkit-fill-available">
                <v-col cols="12" class="pt-0" @click="irArtista(i.uid)">
                  <v-hover v-slot:default="{ hover }">
                    <v-img :id="hover ? 'imagen' : ''" :src="i.imagenPrincipal" aspect-ratio="1"></v-img>
                  </v-hover>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <a @click="irArtista(i.uid)">
                  <h2 class="font-weight-light headline primary--text vietnam">{{i.titulo }}</h2>
                  </a>
                </v-col>
              </v-row>
            </v-col>
          </slide>
        </carousel>
      </v-col>
    </v-row>
    <v-divider style="margin: 0 10%;"/>
    <v-row name="Disenadores" style="margin: 60px 10% 0px 10%;padding:0;">
      <v-col cols="12" align="center">
        <h2 class="error--text pb-5" :style="responsiveTitulo">{{$t('Inicio.DescubreDisenadores').toUpperCase()}}</h2>
      </v-col>
      <v-col cols="12" xs="12" sm="12">
        <carousel v-bind:autoplay="true" v-bind:loop="true" :perPage="perPageCarousel" :autoplayTimeout="8000">
          <slide v-for="i in disenadores" :key="i.titulo">
            <v-col cols="12" xs="12" sm="12">
              <v-row style="width: -webkit-fill-available">
                <v-col cols="12" class="pt-0" @click="irArtista(i.uid)">
                  <v-hover v-slot:default="{ hover }">
                    <v-img :id="hover ? 'imagen' : ''" :src="i.imagenPrincipal" aspect-ratio="1"></v-img>
                  </v-hover>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <a @click="irArtista(i.uid)">
                  <h2 class="font-weight-light headline primary--text vietnam">{{i.titulo }}</h2>
                  </a>
                </v-col>
              </v-row>
            </v-col>
          </slide>
        </carousel>
      </v-col>
    </v-row>
    <v-row name="Magazine" class="padding" style="background: #26A69A">
      <v-col cols="12" align="center" class="my-5 pt-5">
        <h2 class="white--text pb-5" :style="responsiveTitulo">{{$t('Inicio.Magazine').toUpperCase()}}</h2>
      </v-col>
      <!-- EDITORIAL -->
      <v-col cols="12" xs="12" sm="4" class="pb-5 mb-5"  >
        <v-row style="width: -webkit-fill-available">
          <v-col cols="12" class="pt-0"  @click="irEditorial(editorial.enlace)">
            <v-hover v-slot:default="{ hover }">
              <v-img :id="hover ? 'imagen' : ''" :src="editorial.imagenPrincipal" aspect-ratio="1"/>
            </v-hover>
          </v-col>
          <v-col cols="12" align="center" class="pt-0">
            <a @click="irEditorial(editorial.enlace)">
              <h2 class="font-weight-light headline white--text" v-if="getIdioma === 'es'">{{editorial.tituloEs.toUpperCase() }}</h2>
              <h2 class="font-weight-light headline white--text" v-else>{{editorial.tituloEn.toUpperCase() }}</h2>
            </a>
            <p class="body-2 font-weight-regular white--text">{{$t('Categoria.Editorial')}}</p>
      </v-col>
        </v-row>
      </v-col>
      <!-- STORIES -->
       <v-col cols="12" xs="12" sm="4" class="pb-5 mb-5"  >
        <v-row style="width: -webkit-fill-available">
          <v-col cols="12" class="pt-0"  @click="irMagazine(stories.enlace)">
            <v-hover v-slot:default="{ hover }">
              <v-img :id="hover ? 'imagen' : ''" :src="stories.imagenPrincipal" aspect-ratio="1"/>
            </v-hover>
          </v-col>
          <v-col cols="12" align="center" class="pt-0">
            <a @click="irMagazine(stories.enlace)">
              <h2 class="font-weight-light headline white--text" v-if="getIdioma === 'es'">{{stories.tituloEs.toUpperCase()}}</h2>
              <h2 class="font-weight-light headline white--text" v-else>{{stories.tituloEn.toUpperCase()}}</h2>
            </a>
            <p class="body-2 font-weight-regular white--text">{{$t('Categoria.Stories')}}</p>
      </v-col>
        </v-row>
      </v-col>
      <!-- INVITADO -->
       <v-col cols="12" xs="12" sm="4" class="pb-5 mb-5"  >
        <v-row style="width: -webkit-fill-available">
          <v-col cols="12" class="pt-0"  @click="irMagazine(invitado.enlace)">
            <v-hover v-slot:default="{ hover }">
              <v-img :id="hover ? 'imagen' : ''" :src="invitado.imagenPrincipal" aspect-ratio="1"/>
            </v-hover>
          </v-col>
          <v-col cols="12" align="center" class="pt-0">
            <a @click="irMagazine(invitado.enlace)">
              <h2 class="font-weight-light headline white--text" v-if="getIdioma === 'es'">{{invitado.tituloEs.toUpperCase()}}</h2>
              <h2 class="font-weight-light headline white--text" v-else>{{invitado.tituloEn.toUpperCase()}}</h2>
            </a>
            <p class="body-2 font-weight-regular white--text">{{$t('Categoria.Invitado')}}</p>
      </v-col>
        </v-row>
      </v-col>
      <!-- MAGAZINE -->
      <!-- <v-col cols="12" xs="12" sm="4" v-for="i in magazine" :key="i.tituloEs" class="pb-5 mb-5">
        <v-row style="width: -webkit-fill-available">
          <v-col cols="12" class="pt-0" @click="irMagazine(i.enlace)">
            <v-hover v-slot:default="{ hover }">
              <v-img :id="hover ? 'imagen' : ''" :src="i.imagenPrincipal" aspect-ratio="1"></v-img>
            </v-hover>
          </v-col>
          <v-col cols="12" align="center" class="pt-0">
            <a @click="irMagazine(i.enlace)">
              <h2 class="font-weight-light headline white--text" v-if="getIdioma === 'es'">{{i.tituloEs.toUpperCase() }}</h2>
              <h2 class="font-weight-light headline white--text" v-else>{{i.tituloEn.toUpperCase() }}</h2>
            </a>
            <p class="body-2 font-weight-regular white--text">{{$t('Categoria.' + i.categoria)}}</p>
          </v-col>
        </v-row>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { Carousel, Slide } from 'vue-carousel'
import axios from 'axios'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
export default {
  name: 'Inicio',
  data () {
    return {
      duo: null,
      editorial: [],
      articulos: [],
      stories: [],
      magazine: [],
      artistas: [],
      disenadores: []
    }
  },
  components: {
    Carousel,
    Slide
  },
  computed: {
    ...mapGetters(['getArticulos', 'getPaises', 'getIdioma']),
    ...mapMutations(['setAlerta', 'setTextoAlerta']),
    textoInicio () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:2rem;'
        case 'sm': return 'font-size:4rem;'
        case 'md': return 'font-size:3.5rem;'
        case 'lg': return 'font-size:5rem;'
        case 'xl': return 'font-size:5.5rem;'
        default: return 'font-size:5.5rem;'
      }
    },
    responsiveTitulo () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:1.5rem;line-height:1.5rem;letter-spacing:10px;word-break:inherit!important;'
        case 'sm': return 'font-size:3rem;line-height:3rem;letter-spacing:10px;word-break:inherit!important;'
        case 'md': return 'font-size:4rem;line-height:4rem;letter-spacing:10px;word-break:inherit!important;'
        case 'lg': return 'font-size:5rem;line-height:5rem;letter-spacing:10px;word-break:inherit!important;'
        case 'xl': return 'font-size:6rem;line-height:6rem;letter-spacing:10px;word-break:inherit!important;'
        default: return 'font-size:6rem;line-height:7rem;letter-spacing:10px;word-break:inherit!important;'
      }
    },
    responsiveTituloEditorial () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:2rem;line-height:2rem;'
        case 'sm': return 'font-size:3rem;line-height:3rem;'
        case 'md': return 'font-size:3rem;line-height:3rem;'
        case 'lg': return 'font-size:4rem;line-height:3.5rem;'
        case 'xl': return 'font-size:4rem;line-height:3.5rem;'
        default: return 'font-size:4rem;line-height:3.5rem;'
      }
    },
    columnasEditorial () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'order: 1;'
        case 'sm': return 'order: 1;'
        case 'md': return 'order: 4;'
        case 'lg': return 'order: 4;'
        case 'xl': return 'order: 4;'
        default: return 'order: 4;'
      }
    },
    columnas () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'order: 4;'
        case 'sm': return 'order: 4;'
        case 'md': return 'order: 2;'
        case 'lg': return 'order: 2;'
        case 'xl': return 'order: 2;'
        default: return 'order: 2;'
      }
    },
    perPageCarousel () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 1
        case 'sm': return 1
        case 'md': return 2
        case 'lg': return 3
        case 'xl': return 3
        default: return 3
      }
    }
  },
  mounted () {
    // ARTICULOS EDITORIAL
    if (this.getArticulos[0]) {
      this.ordenarArticulos()
    } else {
      var articulos = []
      firebase.firestore().collection('magazine').get().then(response => {
        for (let i = 0; i < response.docs.length; i++) {
          if (response.docs[i].data().publicar === false) {
            continue
          } else {
            articulos.push(response.docs[i].data())
          }
        }
        this.setArticulos(articulos)
        this.ordenarArticulos()
      })
    }
    // ACTUALIZAR PRECIO DOLAR DIARIAMENTE
    axios({
      method: 'get',
      url: 'http://www.floatrates.com/daily/usd.json',
      crossDomain: true
    })
      .then(response => {
        firebase.firestore().collection('utilidades').doc('monetario').update({ dolar: response.data.cop.rate.toFixed() })
        // return res.send(response.data.result.value.toFixed())
        // return console.log(response.cop.rate.toFixed())
      })
      .catch(error => {
        console.log(error)
        // this.setAlerta()
        // this.setTextoAlerta(error)
      })
    firebase.firestore().collection('utilidades').doc('inicio').get().then(info => {
      this.duo = info.data()
    })
    firebase.firestore().collection('magazine').limit(3).get().then(info => {
      for (let i = 0; i < info.docs.length; i++) {
        if (info.docs[i].data().categoria !== 'Editorial' && info.docs[i].data().publicar === true) {
          this.magazine.push(info.docs[i].data())
        }
      }
    })
    firebase.firestore().collection('productos').where('categoria', '==', 'artista').where('aprobado', '==', true).get().then(info => {
      for (let i = 0; i < info.docs.length; i++) {
        this.artistas.push(info.docs[i].data())
      }
    })
    firebase.firestore().collection('productos').where('categoria', '==', 'disenador').where('aprobado', '==', true).get().then(info => {
      for (let i = 0; i < info.docs.length; i++) {
        this.disenadores.push(info.docs[i].data())
      }
    })
    if (this.getRol === 'invitado') {
      setTimeout(() => {
        this.setNewsletter(true)
      }, 60000)
    }
  },
  methods: {
    ...mapMutations(['setArticulos']),
    ordenarArticulos () {
      var meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
      var ordenadoPorMes = this.getArticulos.sort(function (a, b) {
        return meses.indexOf(b.mes) -
              meses.indexOf(a.mes)
      })
      this.articulos = ordenadoPorMes.sort(function (a, b) {
        return b.ano - a.ano
      })
      this.filtrar(this.articulos)
    },
    filtrar (articulos) {
      for (let i = 0; i < articulos.length; i++) {
        if (articulos[i].categoria === 'Invitado' && articulos[i].publicar === true) {
          this.invitado = articulos[i]
          break
        }
      }
      for (let i = 0; i < articulos.length; i++) {
        if (articulos[i].categoria === 'Editorial' && articulos[i].publicar === true) {
          this.editorial = articulos[i]
          // console.log(this.editorial)
          break
        }
      }
      for (let i = 0; i < articulos.length; i++) {
        if (articulos[i].categoria === 'Stories' && articulos[i].publicar === true) {
          this.stories = articulos[i]
          // console.log(this.stories)
          break
        }
      }
    },
    irArtista (artista) {
      // const menu = `${this.$i18n.t('Alias.Usuario')}/${artista}`
      const menu = `${this.$i18n.t('/p')}/${artista}`
      this.$router.push(menu)
    },
    irMagazine (enlace) {
      const menu = `${this.$i18n.t('Alias.Articulo')}/${enlace}`
      this.$router.push(menu)
    },
    irEditorial (enlace) {
      const menu = `${this.$i18n.t('Alias.Articulo')}/${enlace}`
      this.$router.push(menu)
    }
  }
}
</script>

<style>
.v-application a {
  text-decoration: none!important;
}
#duo .v-image__image{
  opacity: 0.6!important;
}
</style>
